var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":"print-view","size":"md","title":"Location data","hide-footer":"","static":"","lazy":""}},[_c('PDFGenerator',{ref:"pdfGeneratorRef",attrs:{"is-loading":false}},[_c('PdfTemplate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }